import { RESET_STATE, UPDATE_ERROR, ACTION_LOGOUT_INITIATED } from '../actions/types';

const initialState = {
	errorState: false,
	reason: '',
};

export default function (state = initialState, action) {
	switch (action.type) {
		case RESET_STATE:
			return initialState;

		case UPDATE_ERROR:
			return {
				...state,
				errorState: Boolean(action.payload.flag),
				reason: action.payload.reason == null ? state.reason : action.payload.reason,
			};
		
		case ACTION_LOGOUT_INITIATED:
			return initialState;	

		default:
			return state;
	}
}
